import Vue from "vue";
import App from "./App.vue";
import "./assets/tailwind.css";
import router from "./router";
import titleMixin from "./mixin/titleMixin.js";

Vue.mixin(titleMixin);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

// module.exports = {
//   chainWebpack: config => config.resolve.symlinks(false)
// }
